import css from './register.module.scss';
import {Tab} from '../../components/tab/tab';
import {Inputbox} from '../../components/inputbox/inputbox';
import {Button} from '../../components/button/button';
import {useState} from 'react';
import {useNavigate} from '@tanstack/react-location';

const phoneInput = <Inputbox placeholder="+1 201 823 4520" type="tel" onValueChange={console.log} />;
const emailInput = <Inputbox placeholder="Email" type="tel" onValueChange={console.log} />;

export const Register = (): JSX.Element => {
	const [input, setInput] = useState(phoneInput);
	const navigate = useNavigate();

	const onTabChange = (name: unknown) => {
		name === 'Phone Number' ? setInput(phoneInput) : setInput(emailInput);
	};

	const onSubmit = () => {
		navigate({to: '/verification'});
	};

	return (
		<div className={css.container}>
			<div className={css.header}>
				<span>THANK YOU!</span>
				<h3>🎁 Claim Your Reward</h3>
				<p>In order to redeem your 2,000 SET tokens, create a SetPay account.</p>
			</div>
			<Tab tabNames={['Phone Number', 'Email']} selected="Phone Number" onChange={onTabChange} />
			<div className={css.inputContainer}>{input}</div>
			<div className={css.buttonContainer}>
				<Button onClick={onSubmit} name="Submit" color="blue" icon="img/checkIconWhite.svg" />
			</div>
		</div>
	);
};
